// Communication Module Types

export enum AnnouncementType {
  INFO = 'INFO',
  IMPORTANT = 'IMPORTANT',
  URGENT = 'URGENT',
  EVENT = 'EVENT'
}

export interface PollOption {
  id: string;
  text: string;
  votes: number;
  displayOrder?: number;
  percentage?: number;
}

export interface DetailedVote {
  optionId: string;
  optionText: string;
  userId: string;
  displayName: string;
  unitId?: string;
  unitName?: string;
  votedAt: string;
}

export interface Poll {
  id: string;
  title: string;
  description?: string;
  status: 'DRAFT' | 'ACTIVE' | 'CLOSED';
  allowMultiple: boolean;
  isAnonymous: boolean;
  startsAt: string;
  endsAt: string;
  createdBy: string;
  /** Secciones a las que aplica (§6.5). Vacío u omitido = todo el residencial. */
  sectionIds?: string[];
  options: PollOption[];
  createdAt: string;
  hasVoted: boolean;
  userVotedOptionIds: string[];
  question?: string;
  // Campos de estadísticas
  totalVotes?: number;
  voterCount?: number;
  unitsVoted?: number;
  totalUnits?: number;
  detailedVotes?: DetailedVote[];
}

export interface PollResults {
  pollId: string;
  title: string;
  totalVotes: number;
  voterCount: number;
  results: Array<{ optionId?: string; text?: string; option?: string; votes: number; percentage: number }>;
  userVoted: boolean;
  userVotes?: string[];
  detailedVotes?: DetailedVote[];
}

export interface Announcement {
  id: string;
  title: string;
  content: string;
  type: AnnouncementType;
  date: string;
  expiresAt?: string;
  attachmentUrl?: string;
  attachmentFileId?: string;
  poll?: Poll;
  /** Secciones a las que aplica (§6.5). Vacío u omitido = todo el residencial. */
  sectionIds?: string[];
  icon?: string; // Ionicons icon name (e.g., 'construct-outline', 'megaphone-outline')
  isPublished?: boolean;
}

export interface UpdateAnnouncementDTO {
  title?: string;
  content?: string;
  type?: AnnouncementType;
  expiresAt?: string;
  attachmentUrl?: string;
  attachmentFileId?: string;
  isPublished?: boolean;
  /** Secciones a las que aplica (§6.5). Vacío u omitido = todo el residencial. */
  sectionIds?: string[];
}
export * from './notification-preferences';
